<template>
  <SidebarLayoutContainer>
    <v-list
      class='ma-0 pa-0'
      v-for='(group, index) in listItems'
      :key='`sidebar_${index}`'
      style='background-color: rgba(0, 0, 0, 0)'
      dense
    >
      <SidebarListGroup
        v-if='group.childItems'
        :group='group'
        :key='`sidebar_${index}`'
      >
        <SidebarChildListItem
          v-for='item in group.childItems'
          :item='item'
          :key='`${item.label}_${item.link}`'
        />
      </SidebarListGroup>
      <SidebarListItem v-else :item='group' :key='`sidebar_${index}`' />
    </v-list>
  </SidebarLayoutContainer>
</template>

<script>
import * as writerRouter from '@/src/routers/writer'
import SidebarLayoutContainer from './Sidebar/SidebarLayoutContainer'
import SidebarListGroup from '../../components/shared/SidebarLayout/SidebarListGroup'
import SidebarChildListItem from '../../components/shared/SidebarLayout/SidebarChildListItem'
import SidebarListItem from '../../components/shared/SidebarLayout/SidebarListItem'

export default {
  name: 'WriterSidebarContainer',
  components: {
    SidebarListItem,
    SidebarChildListItem,
    SidebarListGroup,
    SidebarLayoutContainer
  },
  data () {
    return {
      listItems: [
        {
          label: 'ホーム',
          link: { name: writerRouter.writerDashboard },
          icon: 'mdi-home'
        },
        {
          label: '応募する',
          icon: 'mdi-text-box',
          link: { name: writerRouter.writerOrderBoard }
        },
        {
          label: '執筆する',
          situation: 'site_design_configuration',
          link: { name: writerRouter.writerPosts },
          icon: 'mdi-palette'
        }
      ]
    }
  }
}
</script>
